import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { STripTypeSelection } from '@slg/web-customer-shared';
import { useStore } from '@/composables';


const __default__ = {
  name: 'TripTypeSelection',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['clearBookingRequestError'],
  setup(__props, { emit }) {


const store = useStore();
const getTripType = computed(() => store.getters['booking/getTripType']);

function setTripType(newType: string) {
  store.commit('booking/setTripType', newType);
  emit('clearBookingRequestError');
}

return { __sfc: true,emit, store, getTripType, setTripType, STripTypeSelection }
}

})